import { PhotoIcon } from '@heroicons/react/20/solid';
import Tag from 'components/common/tag';
import { PopoverClose } from 'components/layout/popover';
import { DuctedSwapOption } from 'utils/ducted-component-swap-types';
import { productImageUrl } from 'utils/system-products';
import { PriceDelta, SwapRowCell } from './swap-row-cells';

type DuctedSwapRowsProps = Readonly<{
  options: DuctedSwapOption[];
  currentPrice: number;
  onSelect: (modelKey: string) => void;
}>;

function DuctedSwapPhoto({ option }: Readonly<{ option: DuctedSwapOption }>) {
  return (
    <div className='relative flex h-8 w-12 shrink-0 items-center justify-center overflow-hidden rounded-sm bg-gray-300'>
      <PhotoIcon className='h-4 w-4 text-gray-400' />
      {option.product?.photo && (
        <img
          className='absolute left-0 top-0 h-full w-full object-contain'
          src={productImageUrl(option.product.photo)}
          alt={option.product.name}
        />
      )}
    </div>
  );
}

export default function DuctedSwapRows({
  options,
  currentPrice,
  onSelect
}: DuctedSwapRowsProps) {
  return (
    <>
      {options.map((option) => (
        <PopoverClose
          key={option.key}
          className='group table-row rounded-md px-2 py-1 font-semibold'
          onClick={() => onSelect(option.modelKey)}
        >
          <SwapRowCell first>
            <DuctedSwapPhoto option={option} />
          </SwapRowCell>
          <SwapRowCell>
            <span className='whitespace-nowrap'>{option.modelNumber}</span>
          </SwapRowCell>
          <SwapRowCell>
            <span className='block max-w-[220px] truncate text-left text-xs font-normal text-gray-500'>
              {option.manufacturer}
            </span>
          </SwapRowCell>
          <SwapRowCell>
            <div className='flex items-center gap-1'>
              {option.badges.map((badge) => (
                <Tag key={badge.kind} noWrap text={badge.label} />
              ))}
            </div>
          </SwapRowCell>
          <SwapRowCell>
            {option.product && option.product.fulfillableStock <= 0 ? (
              <Tag noWrap color='red' textColor='white' text='Out of stock' />
            ) : (
              <span />
            )}
          </SwapRowCell>
          <SwapRowCell last>
            {option.price === null ? (
              <span className='text-sm font-semibold text-gray-400'>—</span>
            ) : (
              <PriceDelta price={option.price} currentPrice={currentPrice} />
            )}
          </SwapRowCell>
        </PopoverClose>
      ))}
    </>
  );
}
